import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import type { JSX } from "react";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { BlButton } from "Shared/Buttons/BlButton";
import { StyledDialog } from "Shared/Dialogs/DialogStyles";

type Props = {
  isOpen: boolean;
  handleResult: (result: boolean) => void;
  modalTitle: string | JSX.Element;
  modalContent: string | JSX.Element;
  confirmButtonText?: string;
};

export const BlConfirmDialog = (props: Props): React.ReactNode => {
  const { t } = useResource();
  const { modalContent, modalTitle, confirmButtonText, handleResult, isOpen } =
    props;

  return (
    <StyledDialog open={isOpen} onClose={() => handleResult(false)}>
      <DialogTitle>
        <Typography
          variant="h2"
          component="span"
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            color: (theme) => theme.palette.common.white,
          }}
        >
          {modalTitle}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2">{modalContent}</Typography>
      </DialogContent>

      <DialogActions>
        <BlButton
          sx={{ marginRight: "12px !important" }}
          onClick={() => handleResult(false)}
          paddingLeftRight={Spacing.L}
        >
          {t(Resources.Common.Cancel)}
        </BlButton>
        <BlButton
          color="primary"
          paddingLeftRight={Spacing.L}
          onClick={() => handleResult(true)}
        >
          {confirmButtonText ?? t(Resources.Common.Confirm)}
        </BlButton>
      </DialogActions>
    </StyledDialog>
  );
};
